import './Checkbox.scss'

import { useEffect, useRef, useState } from 'react'

const Checkbox = ({ control, label, disabled = false, defaultValue, onChange }) => {
    const checkboxRef = useRef()

    const onCheckboxChange = (event) => {
        if (control) control.setValue(event.target.checked)
        if (onChange) onChange(event.target.checked)
    }

    const updateFromValue = (value) => {
        if (value !== checkboxRef.current.checked) {
            checkboxRef.current.checked = value
            if (onChange) onChange(value)
        }
    }

    useEffect(() => {
        if (control) updateFromValue(control.value)
    }, [control?.value])

    useEffect(() => {
        updateFromValue(control ? control.value : !!defaultValue)
    }, [])

    return (
        <div className="checkbox">
            <label className="flex-center-y">
                <input type="checkbox" className="real" disabled={disabled} onChange={onCheckboxChange} ref={checkboxRef} hidden />
                <div className="fake flex-center mr-3">
                    <img className="tick" src="/images/icons/tick.svg" />
                </div>
                <span className="label">{label}</span>
            </label>
        </div>
    )
}

export default Checkbox